import './index.css';
import * as React from 'react';
import Header from './components/Header';
import Scroll from './components/Scroll';
import RowsSidebar from './components/RowsSidebar';
import Rows from './components/Rows';
import { fetchData, RoadmapResult } from './core/Api';
import { reset } from './state';
import TasksPanel from './components/TasksPanel';
import { useDateRange, useIsAuthenticated, useTasks } from './state/context';
import SkeletonApp from './components/SkeletonApp';
import { DateRange } from './types';
import { HEADER_HEIGHT } from './layout';

const App = () => {
  const isAuthenticated = useIsAuthenticated();
  const isAuthenticatedRef = React.useRef(isAuthenticated);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [dateRange] = useDateRange();
  const tasks = useTasks();

  const fetch = React.useCallback(
    (range: DateRange) => {
      const [fromDate, toDate] = dateRange;

      setIsLoading(true);

      fetchData({ fromDate, toDate })
        .then(reset)
        .finally(() => setIsLoading(false));
    },
    [dateRange],
  );

  React.useEffect(() => fetch(dateRange), [dateRange]);

  React.useEffect(() => {
    if (!isAuthenticated && isAuthenticatedRef.current) {
      fetch(dateRange);
    }

    isAuthenticatedRef.current = isAuthenticated;
  }, [isAuthenticated]);

  if (isLoading && !tasks.length) {
    return <SkeletonApp />;
  }

  return (
    <>
      {isLoading && (
        <div
          style={{
            top: `${HEADER_HEIGHT}px`,
          }}
          className="absolute inset-0 bg-gray-100 opacity-50 z-50" />
      )}
      <Header />
      <RowsSidebar />
      <Rows />
      <Scroll />
      <TasksPanel />
    </>
  );
};

export default App;
